// src/components/SEOHelmet.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO_CONFIG } from '../config/seo';

const SEOHelmet = ({ 
  title = "Truc Doan - Real Estate Agent | Westminster, CA | VUI Group",
  description = "Truc Doan is a dedicated real estate agent with VUI Group serving all of Southern California. Specializing in residential & commercial real estate, mortgage loans, escrow, and rental management across Los Angeles, Orange County, San Diego, Riverside, San Bernardino, Ventura, and beyond.",
  keywords = "Truc Doan realtor, VUI Group real estate, homes for sale Southern California, buy home Los Angeles, sell home Orange County, Westminster CA real estate, real estate agent Westminster, homes for sale Anaheim, real estate Garden Grove, homes for sale Santa Ana, real estate Irvine, homes for sale Long Beach, real estate Torrance, homes for sale Pasadena, real estate Glendale, homes for sale Burbank, real estate San Diego, homes for sale Riverside, real estate San Bernardino, homes for sale Ventura, real estate Oxnard, homes for sale Thousand Oaks, real estate Temecula, homes for sale Murrieta, real estate Fontana, homes for sale Ontario, real estate Rancho Cucamonga, homes for sale Pomona, real estate El Monte, homes for sale Downey, real estate Compton, homes for sale Inglewood, real estate Hawthorne, homes for sale Carson, real estate Lakewood, homes for sale Whittier, real estate Norwalk, homes for sale West Covina, real estate Covina, homes for sale Baldwin Park, real estate Chino, homes for sale Chino Hills, real estate Corona, homes for sale Moreno Valley, real estate Hemet, homes for sale Palm Springs, real estate Indio, homes for sale Coachella, Vietnamese real estate agent Southern California, CRMLS agent, California Regional MLS, commercial real estate California, rental management Southern California, mortgage loan California, escrow services California",
  canonical = SEO_CONFIG.DOMAIN,
  ogImage = SEO_CONFIG.OG_IMAGE
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Conversational/Chat Keywords */}
      <meta name="chat-keywords" content="ask real estate questions, property chat, home buying help, real estate assistant, talk to agent, property advice" />
      
      {/* Local SEO */}
      <meta name="geo.region" content="US-CA" />
      <meta name="geo.placename" content="Westminster, California" />
      <meta name="geo.position" content={`${SEO_CONFIG.LATITUDE};${SEO_CONFIG.LONGITUDE}`} />
      <meta name="ICBM" content={`${SEO_CONFIG.LATITUDE}, ${SEO_CONFIG.LONGITUDE}`} />
      <meta name="author" content="Truc Doan" />
      <meta name="robots" content="index, follow" />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Truc Doan Real Estate" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Structured Data for Real Estate Agent */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "RealEstateAgent",
          "name": "Truc Doan",
          "telephone": SEO_CONFIG.AGENT_PHONE,
          "email": SEO_CONFIG.AGENT_EMAIL,
          "url": SEO_CONFIG.DOMAIN,
          "image": SEO_CONFIG.OG_IMAGE,
          "description": "Truc Doan is a dedicated real estate agent with VUI Group serving all of Southern California. Specializing in residential & commercial real estate, mortgage loans, escrow, and rental management.",
          "areaServed": [
            "Los Angeles County, CA",
            "Orange County, CA",
            "San Diego County, CA",
            "Riverside County, CA",
            "San Bernardino County, CA",
            "Ventura County, CA",
            "Santa Barbara County, CA",
            "San Luis Obispo County, CA"
          ],
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Westminster",
            "addressRegion": "CA",
            "postalCode": "92683",
            "addressCountry": "US"
          },
          "memberOf": {
            "@type": "Organization",
            "name": "VUI Group"
          },
          "hasCredential": {
            "@type": "EducationalOccupationalCredential",
            "credentialCategory": "Real Estate License",
            "recognizedBy": {
              "@type": "Organization",
              "name": "California Department of Real Estate"
            },
            "identifier": "02060851"
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEOHelmet;